import props from './props'

export default {
  props
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/components/graduations/resources/index.js